import React from 'react'
import { getOVSearchCriteria, getSearchCriteria } from './LoadSavedSearch/LoadSavedSearch'
import GetSearchResult from './GetSearchResult/GetSearchResult'
import HospitalityIcon from '../Assets/MapIcons/HospitalityIcon.png'
import HealthCareIcon from '../Assets/MapIcons/HealthCareIcon.png'
import LandIcon from '../Assets/MapIcons/LandIcon.png'
import StudentHousingIcon from '../Assets/MapIcons/StudentHousingIcon.png'
import IndustrialIcon from '../Assets/MapIcons/IndustrialIcon.png'
import OtherIcon from '../Assets/MapIcons/OtherIcon.png'
import OfficeIcon from '../Assets/MapIcons/OfficeIcon.png'
import RetailIcon from '../Assets/MapIcons/RetailIcon.png'
import MultifamilyIcon from '../Assets/MapIcons/MultifamilyIcon.png'
import envConfig from '../../../Components/Common/envConfig/envConfig'

function validateYear(inputVal) {
  let newVal = inputVal
  try {

    if (inputVal !== '' && isNaN(inputVal)) {
      newVal = newVal.substring(0, newVal.length - 1)
      if (isNaN(newVal)) {
        newVal = ''
      }
    }

    if (inputVal.length > 4) {
      newVal = newVal.substring(0, 4)
    }

  } catch (error) {
    console.log('validateYear :: ', error.message)
  }

  return newVal

}

function validateMaxAllowedValue(inputVal, maxInputValue = '') {
  let newVal = inputVal
  let maxAllowedValue

  if (newVal.includes('.')) {
    maxAllowedValue = maxInputValue === '' ? 9999999999 : parseFloat(maxInputValue)
  } else {
    maxAllowedValue = maxInputValue === '' ? 9999999999 : parseInt(maxInputValue, 10)
  }

  if (newVal > maxAllowedValue) {
    newVal = newVal.substring(0, newVal.length - 1)
    if (isNaN(newVal)) {
      newVal = ''
    }
  }

  return newVal
}

function validateNumber(inputVal) {
  let newVal = inputVal

  try {

    if (inputVal !== '' && isNaN(inputVal)) {
      newVal = newVal.substring(0, newVal.length - 1)
      if (isNaN(newVal)) {
        newVal = ''
      }
    }

    if (inputVal.length > 10) {
      newVal = newVal.substring(0, 10)
    }

    if (newVal.includes('.')) {
      const lstNewVal = newVal.split('.')
      if (lstNewVal[1].length > 2) {
        newVal = `${lstNewVal[0]}.${lstNewVal[1].substring(0, 2)}`
      }
    }

  } catch (error) {
    console.log('validateNumber :: ', error.message)
  }

  return newVal

}

export function validateInputField(input, type, maxInputValue = '') {
  let newVal = input

  if (newVal === undefined || newVal === null) {
    newVal = ''
  }
  if (type === 'date') {
    newVal = validateYear(newVal)
  }
  if (type === 'number' || type === 'currency') {
    newVal = validateNumber(newVal)

    if (maxInputValue && maxInputValue !== '') {
      newVal = validateMaxAllowedValue(newVal, maxInputValue)
    }
  }

  return newVal

}

export function getFormattedDate(value) {
  let newVal = value
  if (newVal === undefined || newVal === null || newVal === '') {
    newVal = ''
  } else {
    const dt = new Date(newVal)
    const offsetDt = new Date((dt.getTime() + dt.getTimezoneOffset()) * 60000)
    const date = new Date(offsetDt)

    const year = date.getFullYear()
    let month = (1 + date.getMonth()).toString()
    month = month.length > 1 ? month : `0${month}`
    let day = date.getDate().toString()
    day = day.length > 1 ? day : `0${day}`

    newVal = `${month}/${day}/${year}`
  }

  return newVal
}

// function SanitizeUrl(url) {
//   const regex = new RegExp(/[^-A-Za-z0-9+&@#/%?=~_|!:,.;\(\)]/gm)
//   return url.replace(regex, "");
// }

function sanitizeUrl(req) {
  let returnVal = ''
  const format = /<[^>]*>/gm

  if (req && !req.toString().match(format)) {
    returnVal = req
  }

  return returnVal
}

export function getQueryStringValue(myParam) {

  // const urlParams = new URLSearchParams(window.location.search)
  let returnVal = decodeURIComponent(encodeURIComponent(new URLSearchParams(window.location.search).get(myParam)))
  returnVal = returnVal == 'null' ? null : returnVal

  return returnVal
  // let myParamValue = urlParams.get(myParam)
  // myParamValue = myParamValue ? sanitizeUrl(myParamValue) : myParamValue
  // return myParamValue
}

export function getUserSFId() {
  return getQueryStringValue('userId') ? getQueryStringValue('userId') : ''
}


export function formatDate(date, format = 'mmDDYYYY') {
  let today = new Date(date)
  today = new Date(today.getTime() + today.getTimezoneOffset() * 6000)
  let dd = today.getDate()
  let mm = today.getMonth() + 1
  const yyyy = today.getFullYear()
  if (dd < 10) {
    dd = `0${dd}`
  }
  if (mm < 10) {
    mm = `0${mm}`
  }
  let dtFromatted
  if (format === 'mmDDYYYY') {
    dtFromatted = `${mm}-${dd}-${yyyy}`
  } else if (format === 'ddMMYYYY') {
    dtFromatted = `${dd}-${mm}-${yyyy}`
  } else if (format === 'yyyyMMDD') {
    dtFromatted = `${yyyy}-${mm}-${dd}`
  }

  return dtFromatted
}

export function displayDateFormat(date) {
  // Example : "saleDate": "2021-09-30",
  // Output  : 09-30-2021
  let dtFromatted = ''

  if (date && date !== undefined && date !== null && date !== '') {
    // console.log(' displayDateFormat date ', date)
    let dateSplit = date.split('-')
    if (dateSplit.length > 2) {
      // console.log(' displayDateFormat dateSplit ', dateSplit)
      dtFromatted = `${dateSplit[1]}-${dateSplit[2]}-${dateSplit[0]}`
      // console.log(' displayDateFormat dtFromatted ', dtFromatted)
    }
  }


  return dtFromatted
}



export function commaFormatted(value, isCurrency) {
  if (!isNaN(value)) {
    let result = Number(value).toLocaleString("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 0 });
    return isCurrency ? result : result.replace(/\$/g, '')
  }
  return ""
}

export function removeSpecialCharacters(inputVal) {
  let newVal = inputVal

  try {
    newVal = newVal.replace(/[^a-zA-Z0-9 ]/g, '')
  } catch (error) {
    console.log('removeSpecialCharacters :: ', error.message)
  }

  return newVal

}

export function removeWhiteSpace(inputVal) {
  let newVal = inputVal

  try {
    newVal = newVal.trim()
    newVal = newVal.replace(/\s+/g, ' ')
  } catch (error) {
    console.log('removeSpecialCharacters :: ', error.message)
  }

  return newVal

}

export function isFilterApplied(searchCriteria) {
  let returnVal = false
  for (const [key] of Object.entries(searchCriteria)) {
    if (Array.isArray(searchCriteria[key])) {
      if (searchCriteria[key].length > 0) {
        returnVal = true
      }
    }
    if (key === 'subjectProperty' && searchCriteria[key].propertyName) {
      returnVal = true
    }
    if (key === 'property' && searchCriteria[key].propertyName) {
      returnVal = true
    }
    if (key === 'polygon' && searchCriteria[key].points.length > 0) {
      returnVal = true
    }
  }

  return returnVal
}

function toRad(num) {
  return (num * Math.PI) / 180;
}

export function distance(lon1, lat1, lon2, lat2) {
  let distInMiles = ''
  try {
    let R = 6371 // Radius of the earth in km
    let dLat = toRad(lat2 - lat1) // Javascript functions in radians
    let dLon = toRad(lon2 - lon1)
    let a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) *
      Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2)
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
    let d = R * c // Distance in km
    let distInKM = d
    distInMiles = distInKM * 1000 * 0.00062137 // Distance in Mile
    //let distInYard = distInKM * 1093.6   // Distance in Yard
    return distInMiles.toFixed(2)
  } catch (e) {
    console.log(e.message)
    return distInMiles
  }
}

export function distanceFromSubject(data, searchCriteria) {

  const i = data.findIndex(x => x.omniViewPropertyId === searchCriteria.subjectProperty.omniViewPropertyId)

  if (i !== -1) {
    let distanceFromSubject = ''
    data.forEach(item => {

      if (data[i].propertyLocation && item.propertyLocation) {
        let subjectLocation = data[i].propertyLocation.split(',')
        let propertyLocation = item.propertyLocation.split(',')
        distanceFromSubject = distance(subjectLocation[1], subjectLocation[0], propertyLocation[1], propertyLocation[0])

      }

      item.distanceFromSubject = distanceFromSubject

    })

  }

  return data
}

// export function scrollToElement(elem) {
//   try {
//     let elmnt = document.getElementById(elem);
//     elmnt.scrollIntoView({ block: 'start', behavior: 'smooth' });
//   } catch (error) {
//     console.log('error in scrollToElement:::', error)
//   }
// }

export function determineENV(inputVal) {
  let env = 'dev'
  const location = window.location.hostname
  // console.log(location)
  if (location.includes('qc')) {
    env = 'qc'
  }
  if (!location.includes('qc') && !location.includes('local')) {
    env = 'prod'
  }

  if (inputVal === env) {
    return true
  } else {
    return false
  }

  // return env
}

export function currentENV() {
  let env = 'dev'
  const location = window.location.hostname

  if (location.includes('berkaida360.qcberk8s.com')) {
    env = 'qc'
  }

  if (location.includes('berkadia360.berkadia.com') || location.includes('berkadia360.prodberk8s.com')) {
    env = 'prod'
  }

  return env
}

export function getDateTimeRangeSelection(val) {
  if (!isNaN(val)) {
    const dt = new Date()
    dt.setMonth(dt.getMonth() + parseInt(val))
    return formatDate(dt, 'yyyyMMDD')
  }
  return ''
}

export function highlightText(inputString, textToHighlight) {

  textToHighlight = textToHighlight.toLowerCase()
  textToHighlight = removeWhiteSpace(textToHighlight)

  let splitInput = inputString ? inputString.split(',') : ['']

  const getBoldText = value => {
    let newInput = value ? value.toLowerCase() : ''
    let tempSplitInput = newInput.split(textToHighlight)

    if (tempSplitInput.length === 1) {
      tempSplitInput = [value]
    }

    return (
      <>
        <span className="">
          {
            tempSplitInput.length === 1 ?
              tempSplitInput[0] :

              <span className="capitalize">
                {tempSplitInput.map((value, index) => (
                  <>
                    {index + 1 >= tempSplitInput.length ?
                      value
                      : <span>{value}<b>{textToHighlight}</b></span>}
                  </>
                ))}
              </span>
          }
        </span>
      </>
    )
  }

  return (
    <>
      <span>
        {splitInput.map((value, index) => (
          <>
            {index > 0 ? ',' : null}
            {getBoldText(value)}
          </>
        ))}
      </span>
    </>
  )
}

export function getStates() {
  return [
    { label: "Alabama", value: "AL" },
    { label: "Alaska", value: "AK" },
    { label: "American Samoa", value: "AS" },
    { label: "Arizona", value: "AZ" },
    { label: "Arkansas", value: "AR" },
    { label: "California", value: "CA" },
    { label: "Colorado", value: "CO" },
    { label: "Connecticut", value: "CT" },
    { label: "Delaware", value: "DE" },
    { label: "District of Columbia", value: "DC" },
    { label: "Florida", value: "FL" },
    { label: "Georgia", value: "GA" },
    { label: "Guam", value: "GU" },
    { label: "Hawaii", value: "HI" },
    { label: "Idaho", value: "ID" },
    { label: "Illinois", value: "IL" },
    { label: "Indiana", value: "IN" },
    { label: "Iowa", value: "IA" },
    { label: "Kansas", value: "KS" },
    { label: "Kentucky", value: "KY" },
    { label: "Louisiana", value: "LA" },
    { label: "Maine", value: "ME" },
    { label: "Maryland", value: "MD" },
    { label: "Massachusetts", value: "MA" },
    { label: "Michigan", value: "MI" },
    { label: "Minnesota", value: "MN" },
    { label: "Mississippi", value: "MS" },
    { label: "Missouri", value: "MO" },
    { label: "Montana", value: "MT" },
    { label: "Nebraska", value: "NE" },
    { label: "Nevada", value: "NV" },
    { label: "New Hampshire", value: "NH" },
    { label: "New Jersey", value: "NJ" },
    { label: "New Mexico", value: "NM" },
    { label: "New York", value: "NY" },
    { label: "North Carolina", value: "NC" },
    { label: "North Dakota", value: "ND" },
    { label: "Northern Mariana Is", value: "MP" },
    { label: "Ohio", value: "OH" },
    { label: "Oklahoma", value: "OK" },
    { label: "Oregon", value: "OR" },
    { label: "Pennsylvania", value: "PA" },
    { label: "Puerto Rico", value: "PR" },
    { label: "Rhode Island", value: "RI" },
    { label: "South Carolina", value: "SC" },
    { label: "South Dakota", value: "SD" },
    { label: "Tennessee", value: "TN" },
    { label: "Texas", value: "TX" },
    { label: "Utah", value: "UT" },
    { label: "Vermont", value: "VT" },
    { label: "Virginia", value: "VA" },
    { label: "Virgin Islands", value: "VI" },
    { label: "Washington", value: "WA" },
    { label: "West Virginia", value: "WV" },
    { label: "Wisconsin", value: "WI" },
    { label: "Wyoming", value: "WY" }
  ];
}

export function loadData(response, searchCriteria, setSearchResult) {

  try {
    if (response.data && response.data.data) {
      let data = response.data.data

      if (data.length > 0) {
        if (searchCriteria.subjectProperty && searchCriteria.subjectProperty.propertyName) {
          data = distanceFromSubject(data, searchCriteria)
        }

        setSearchResult({ property: data, totalCount: response.data.total })
      }

    }
  } catch (error) {
    console.log('error in loadData = ', error)
  }

}

export function getSearchCriteriaToSave(searchCriteria) {
  let newSearchCriteria = { ...searchCriteria }
  try {
    delete newSearchCriteria.pagination
    for (const [key] of Object.entries(newSearchCriteria)) {
      if (Array.isArray(newSearchCriteria[key])) {
        if (!newSearchCriteria[key].length) {
          delete newSearchCriteria[key]
        }
      }
    }
    if (!newSearchCriteria.subjectProperty.propertyName) {
      delete newSearchCriteria.subjectProperty
    }
    if (!newSearchCriteria.property.propertyName) {
      delete newSearchCriteria.property
    }
    // if sort is empty, removing it
    if (Object.keys(newSearchCriteria.sort).length === 0 && newSearchCriteria.sort.constructor === Object) {
      delete newSearchCriteria.sort
    }
  }
  catch (e) {
    console.log('Error :: ', e)
  }

  return newSearchCriteria
}

export function clearSelectedProperties(searchResult, setSearchResult) {
  var newData = searchResult.property.map(prop => {
    if (prop.checked)
      return Object.assign({}, prop, { checked: false })
    return prop
  });
  setSearchResult({ property: newData, totalCount: searchResult.totalCount })
}

export function viewList(listId, list_ov_id, setSelectedMenu) {
  try {

    window.history.pushState({}, 'Property List', `/PropertyList?userId=${getQueryStringValue('userId')}&view=lists&list_id=${listId}&list_ov_id=${list_ov_id}`)

    setSelectedMenu('list')

  } catch (e) {
    console.log('Error in viewList::: ', e)
  }
}

export function getTargetMarketPayload(savedSearch) {
  let returnVal = ''
  try {

    const index = savedSearch.findIndex(x => x.isTargetMarket)
    let targetMarketFields

    if (index !== -1) {

      if (savedSearch[index].polarisSearchCriteria && savedSearch[index].polarisSearchCriteria !== '') {
        targetMarketFields = getSearchCriteria(savedSearch[index].polarisSearchCriteria)
      }
      else {
        targetMarketFields = getOVSearchCriteria(savedSearch[index].omniViewSearchCriteria)
      }
      // if (savedSearch[index].omniViewSearchCriteria && savedSearch[index].omniViewSearchCriteria !== '') {
      //   targetMarketFields = getOVSearchCriteria(savedSearch[index].omniViewSearchCriteria)
      // }
      // else {
      //   targetMarketFields = getSearchCriteria(savedSearch[index].polarisSearchCriteria)
      // }

      const getSearchResult = new GetSearchResult(targetMarketFields, function () { })
      const response = getSearchResult.createPayload()
      delete response['pagination']
      delete response['sort']
      delete response['subjectProperty']

      // console.log('response = ', response)

      returnVal = response

    }

  } catch (error) {
    console.log('error in getTargetMarketPayload = ', error)
  }

  return returnVal
}

export function getPropertyTypeIcon(propertyType) {
  try {
    let returnVal

    switch (propertyType) {
      case 'Health Care':
        returnVal = HealthCareIcon
        break;
      case 'Hospitality':
        returnVal = HospitalityIcon
        break;
      case 'Land':
        returnVal = LandIcon
        break;
      case 'Student Housing':
        returnVal = StudentHousingIcon
        break;
      case 'Industrial':
        returnVal = IndustrialIcon
        break;
      case 'Office':
        returnVal = OfficeIcon
        break;
      case 'Retail':
        returnVal = RetailIcon
        break;
      case 'Multifamily':
        returnVal = MultifamilyIcon
        break;
      default:
        returnVal = OtherIcon
        break;
    }

    return returnVal

  } catch (e) {
    console.log('Error in getPropertyTypeIcon::: ', e)
  }
}

export function getPollingAlertDuration() {
  return envConfig[currentENV()].POLLING_ALERT_DURATION
}

export function getErrorAlertDuration() {
  return envConfig[currentENV()].ERROR_ALERT_DURATION
}
